<template>
  <div v-if="editedSpecialBet">
    <div class="form-group">
      <label for="descriptionTextArea">Beschreibung</label>
      <textarea id="descriptionTextArea"
                class="form-control"
                rows="3"
                v-model="editedSpecialBet.description"/>
      <label for="startTextField">Tippstart</label>
      <input id="startTextField"
             type="datetime-local"
             class="form-control form-text"
             v-model="editedSpecialBet.start"/>
      <label for="startTextField">Tippschluss</label>
      <input id="deadlineTextField"
             type="datetime-local"
             class="form-control form-text"
             v-model="editedSpecialBet.deadline"/>
      <label for="valueTextField">Tippwert</label>
      <input id="valueTextField"
             type="number"
             class="form-control form-text"
             v-model="editedSpecialBet.value"/>
      <div class="form-check mt-2">
        <input id="enableQuotasCheckbox"
               type="checkbox"
               class="form-check-input"
               v-model="editedSpecialBet.quotaEnabled"/>
        <label for="enableQuotasCheckbox"
               class="form-check-label">
          Quoten
        </label>
      </div>
      <div class="form-check mt-2">
        <input id="enableEmblemsCheckbox"
               type="checkbox"
               class="form-check-input"
               v-model="editedSpecialBet.useEmblems"/>
        <label for="enableEmblemsCheckbox"
               class="form-check-label">
          Teamwappen verwenden
        </label>
      </div>
      <label class="mt-2 mb-1" for="optionsFormGroup">Optionen</label>
      <div id="optionsFormGroup" class="form-group">
        <div v-for="(option, idx) in editedSpecialBet.options"
             :key="'option_' + idx"
             class="row mt-1">
          <real-team-input v-model="option.name"
                           v-if="editedSpecialBet.useEmblems"
                           :suggestion-data="filteredRealTeams"
                           :initial-display-value="option.name"
                           @filter="realTeamFilter = $event"
                           placeholder="Tippen für Vereinsvorschläge"
                           class="col-6"
                           :disabled="editedSpecialBet.finished">
            <template v-slot:suggestion="{suggestion}">
              <cld-image
                  :public-id="'/sandkastenliga/realteams/' + generateTeamIdFromName(suggestion)"
                  v-if="editedSpecialBet.useEmblems"
                  width="17"
                  height="17"
                  crop="fill"
                  dpr="auto"
                  class="d-inline-flex align-middle"/>
              {{ suggestion }}
            </template>
          </real-team-input>
          <div v-else
               class="col-6">
            <input v-model="option.name"
                   type="text"
                   class="form-control form-text"/>
          </div>
          <div class="col-3">
            <div v-if="option.correct"
                 class="ms-1 text-success">
              korrekt
            </div>
            <span v-if="option.out"
                  class="ms-1 text-warning">
                        draußen
                    </span>
            <button v-if="started && !option.out && !option.correct"
                    class="btn btn-sm btn-warning ms-1 text-light"
                    @click="option.out = true"
                    :disabled="editedSpecialBet.finished">
              ausschließen
            </button>
            <span v-if="!started"
                  class="link text-danger font-weight-bold"
                  @click="removeOption(idx)"
                  style="font-size: xx-large"
                  :disabled="editedSpecialBet.finished">
              &times;
            </span>
          </div>
          <div v-if="started" class="col-2 text-end">{{ option.quota | float }}</div>
        </div>
        <div class="row text-center mt-0">
          <div class="col">
            <span v-if="!started"
                  class="link text-success font-weight-bold"
                  style="font-size: xx-large"
                  @click="addBlankOption">+
            </span>
          </div>
        </div>
      </div>
      <div class="form-group mt-2"
           v-if="started">
        <label for="resultSelect">Resultat</label>
        <select class="form-control mt-1"
                id="resultSelect"
                v-model="editedSpecialBet.result"
                :disabled="editedSpecialBet.finished">
          <option v-for="(option, idx) in validResultOptions"
                  :key="'result_' + idx">{{ option.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="text-end mt-2">
      <button class="btn btn-danger"
              @click="$emit('cancel')">
        Abbrechen
      </button>
      <button class="ms-1 btn btn-success" @click="$emit('save', editedSpecialBet)">Speichern</button>
    </div>
  </div>
</template>

<script>
import TypeaheadInput from "../../components/global/TypeaheadInput";
import api from "../../sakali-api";

export default {
  props: {
    specialBet: Object
  },
  data() {
    return {
      editedSpecialBet: this.specialBet,
      dirty: true,
      realTeamFilter: null,
      filteredRealTeams: []
    }
  },
  computed: {
    started() {
      return this.editedSpecialBet.id
          && new Date(this.editedSpecialBet.deadline) - new Date() < 0;
    },
    validResultOptions() {
      return this.editedSpecialBet.options.filter(o => !o.out);
    }
  },
  methods: {
    updateFilteredRealTeams() {
      api.get('/realteams', {
        params: {
          q: this.realTeamFilter
        }
      }).then(response => {
        this.filteredRealTeams = response.data
      });
    },
    removeOption(idx) {
      this.$delete(this.editedSpecialBet.options, idx);
    },
    addBlankOption() {
      this.editedSpecialBet.options.push({
        name: '',
        correct: false,
        suggestions: [],
        out: false,
        quota: 0,
        selected: false
      })
    }
  },
  watch: {
    specialBet() {
      this.editedSpecialBet = JSON.parse(JSON.stringify(this.specialBet));
    },
    realTeamFilter() {
      this.updateFilteredRealTeams()
    }
  },
  mounted() {
  },
  components: {
    realTeamInput: TypeaheadInput
  }
}
</script>
